import request from '../axiosInterceptor'
import { ClientConfig, RiskConfig } from '../../types/naiConnect'

// nAI Connect admin API — proxied through the asgard admin service so the
// X-Admin-Key stays server-side. Calls go through the normal authed axios
// instance (operator access-token); the backend maps /v1/nai-connect/<x> to
// the nAI Connect admin route and injects the key.
const BASE = `${process.env.REACT_APP_API_BASEURL}v1/nai-connect/`

const api = {
  // --- clients ---
  getNaiClients() {
    return request({ url: `${BASE}clients`, method: 'get' })
  },
  getNaiClient(id: string) {
    return request({ url: `${BASE}clients/${id}`, method: 'get' })
  },
  createNaiClient(data: { name: string }) {
    return request({ url: `${BASE}clients`, method: 'post', data })
  },

  // --- keys ---
  getNaiKeys(id: string) {
    return request({ url: `${BASE}clients/${id}/keys`, method: 'get' })
  },
  issueNaiKey(id: string, data: { name: string; rate_limit_per_min: number; expires_in_days?: number }) {
    return request({ url: `${BASE}clients/${id}/keys`, method: 'post', data })
  },
  revokeNaiKey(keyId: string) {
    return request({ url: `${BASE}keys/${keyId}/revoke`, method: 'post' })
  },

  // --- config ---
  getNaiConfig(id: string) {
    return request({ url: `${BASE}clients/${id}/config`, method: 'get' })
  },
  putNaiConfig(id: string, data: ClientConfig) {
    return request({ url: `${BASE}clients/${id}/config`, method: 'put', data })
  },
  getNaiRiskConfig(id: string) {
    return request({ url: `${BASE}clients/${id}/risk-config`, method: 'get' })
  },
  putNaiRiskConfig(id: string, data: RiskConfig) {
    return request({ url: `${BASE}clients/${id}/risk-config`, method: 'put', data })
  },

  // --- request logs (cursor pagination) ---
  getNaiLogs(id: string, params: LogQuery) {
    const qs = new URLSearchParams()
    if (params.limit) qs.set('limit', String(params.limit))
    if (params.cursor) qs.set('cursor', params.cursor)
    if (params.status_class) qs.set('status_class', params.status_class)
    if (params.intent) qs.set('intent', params.intent)
    if (params.from_date) qs.set('from_date', params.from_date)
    if (params.to_date) qs.set('to_date', params.to_date)
    return request({ url: `${BASE}clients/${id}/logs?${qs.toString()}`, method: 'get' })
  },
}

export type LogQuery = {
  limit?: number
  cursor?: string
  status_class?: string
  intent?: string
  from_date?: string
  to_date?: string
}

export default api
